// Local And Server Base Urls
// export const baseUrl ="https://staging.jobportalapi.atwpl.com/";
// export const baseUrl = "https://jobportalapi.atwpl.com";
// export const baseUrl = "https://dev.jobportalapi.atwpl.com";
// export const baseUrl = "https://uatcatzapi.nubiz.co.in";
export const baseUrl = "https://api.catzapp.com/";

// Total 49 api post?get

//

// End Points

export const registrationUrl = "register/";
export const loginUrl = "login/";
export const job_category_url = "recruiter/JobCategories/";
export const ALL_CATEGORIES = "recruiter/all_categories/";
export const skills_url = "recruiter/skills/";
export const experiance_url = "recruiter/experience/";
export const degree_url = "recruiter/degree/";
export const vaccancy_url = "recruiter/post_vacancy_card/";
export const RECOMMENDED_CANDIDATES = "recruiter/RecommendedCandidate_Dashboard/";
export const ADMIN_JOBCATEGORY = "adminportal/JobCategories/";
export const APPLICANT = "recruiter/applicants/";
export const HIRE = "recruiter/hire/";
export const RECRUITER_PLAYLIST = "recruiter/recruiterplaylist/";
export const COMPANY_LIST = "recruiter/company/";
export const EMAIL = "recruiter/email/";
export const RECURITER_PROFILE = "recruiter/profile_v1/";
export const CONTACT_US = "recruiter/contact_support/";
export const UNLOCKED_PROFILES = "recruiter/unlocked_profiles/";
export const UNLOCKED_PROFILESS = "recruiter/unlocked_profiles_v1/"; 
export const HIRE_LIST = "recruiter/hirelist/";
export const LOGOUT = "logout/";
export const RECURITER_TIMESHEET = "recruiter/timesheet/";
export const SEND_OTP = "send/otp/";
export const VERIFY_OTP = "verify/otp/";
export const Credit_BALANCE = "recruiter/creditbalancehistory/";
// export const SELECT_CANDIDATE = "/recruiter/selected_candidate/";
export const CANDIDATE_NEAR_ME = "recruiter/candidate_Near_Me_v1/";
export const Recruiter_Profile_Status = "recruiter/profile_v1/";
export const SearchEvent = "recruiter/searchevent_v1/";
export const RECURITER_APPLICANTS = "recruiter/applicants/";
export const LOCATION = "recruiter/location/";
export const SUBUSER = "recruiter/subuser/";
export const MYLISTS = "recruiter/recruiterplaylist/";
export const ADDTO_LIST = "recruiter/add_to_playlist/";
export const Recharge_Credit = "recruiter/rechargecredit";
export const GOOGLE_PACES_API_BASE_URL = 'https://maps.googleapis.com/maps/api/place';
export const GOOGLE_PLACES_API_KEY = 'AIzaSyAn7_5pFRSJ_i1lbbiitBzZinnYY7VTGxk';
export const RECURITER_STOREMESSAGES = "recruiter/jobseekerstoremesaages/";
export const RECURITER_CREDITHISTORY = "recruiter/credit_history/";
export const RECURITER_NOTIFICATIONSLOG = "recruiter/recruiter_notifications_log_get/";
// export const Recharge_Credit = "/recruiter/rechargecredit";
// export const GOOGLE_PACES_API_BASE_URL =
//   "https://maps.googleapis.com/maps/api/place";
// export const GOOGLE_PLACES_API_KEY = "AIzaSyAn7_5pFRSJ_i1lbbiitBzZinnYY7VTGxk";
// export const RECURITER_STOREMESSAGES = "/recruiter/jobseekerstoremessages/";
// export const RECURITER_TIMESHEET="/recruiter/time_sheet/"
export const UNLOCKNOW = "recruiter/unlocknow/";
export const Selected_Candidate = "recruiter/selected_candidate/";
export const JOBSEEKER_CHATS = "recruiter/jobseekerstoremessages/";
export const RESET_PWD = "ResetPassword/";
export const Categories_Count = "recruiter/count_all_jobseeker/";
export const Count_Seekers = "recruiter/count_seekers_v1/";
export const UPDATE_PASSWORD = "ResetPassword/";
export const My_Subscription = "recruiter/mysubscription/";
export const Subscription_Plan = "recruiter/upgrade_plan/";
export const Make_Admin = "recruiter/make_admin/";
export const Subuser_Upload_Image = 'recruiter/subuser_image/';
export const Jobseeker_TimeSheet = 'jobseeker/timesheet/?timesheet_id=';
export const Recruiter_Create_Message = 'recruiter/jobseekerstoremessages/';
export const Recruiter_Get_Chats = 'recruiter/jobseekerstoremessages/';
export const Last_Message = 'recruiter/last_message/';
export const TIMESHEET_DOWNLOAD = "jobseeker/timesheet/?timesheet_id=";
export const Social_login = "social_login/";
export const Reset_counter = "recruiter/reset_counter/"
export const Beforlogin = 'recruiter/jobseeker_details/'
export const Afterlogin = 'recruiter/seeker_details/'
export const Recomended_Messages = 'recommended_message/'
export const Forget_password = 'update_password/'
export const Payment_sheet = 'manage_plan_txn/'
export const countNearby = 'recruiter/countseekers/'
export const Get_Profile = 'recruiter/candidateProfile/'
export const getCountwithtoken = 'recruiter/count_seekers_v1/'
export const GET_SEEKER_PROFILE = "recruiter/candidateProfile_v1/"
export const NEARME = 'recruiter/candidate_Near_Me_v1/'
export const POSTVACANCY = 'recruiter/post_vacancy/'
export const CREDIT_VALUE = 'recruiter/credit_value/'
export const APPLICANTSV1= 'recruiter/applicants_v1/'